import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';

import { setModo } from './financeiroActions';

const PARCELAS = Array.from({ length: 6 }, (_, indice) => ({
    id: indice + 1,
    valor: indice === 0
        ? '1 vez'
        : `${indice + 1} vezes`
}));

const hoje = () => {
    const data = new Date();
    data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
    return data.toISOString().substring(0, 10);
};

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return 0;
    }

    const texto = valor.toString().trim();
    const possuiMilhar = /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const normalizado = texto.includes(',') || possuiMilhar
        ? texto.replace(/\./g, '').replace(',', '.')
        : texto;
    const resultado = Number(normalizado);

    return Number.isFinite(resultado) ? resultado : 0;
};

const criarFormulario = tipo => {
    let FinanceiroForm = props => {
        const formulario = props.formulario || {};
        const somenteLeitura = props.cancelamento ? 'readOnly' : '';
        const baixado = numero(formulario.valor_baixado);
        const origemAutomatica =
            formulario.origem && formulario.origem !== 'MANUAL';
        const formaPagamento = props.formasPagamento.find(item =>
            String(item.id) ===
                String(formulario.id_forma_pagamento)
        );

        useEffect(() => {
            if (
                !formulario.id &&
                !formulario.id_forma_pagamento
            ) {
                const formaPadrao = props.formasPagamento.find(
                    item => item.codigo === 'A_VISTA'
                );

                if (formaPadrao) {
                    props.change(
                        'id_forma_pagamento',
                        formaPadrao.id
                    );
                    props.change('quantidade_parcelas', 1);
                }
            }
        }, [
            formulario.id,
            formulario.id_forma_pagamento,
            props.formasPagamento
        ]);

        const alterarFormaPagamento = idFormaPagamento => {
            const forma = props.formasPagamento.find(item =>
                String(item.id) === String(idFormaPagamento)
            );

            props.change(
                'id_forma_pagamento',
                Number(idFormaPagamento)
            );

            if (forma && !forma.permite_parcelamento) {
                props.change('quantidade_parcelas', 1);
            }
        };

        const marcarIntegral = () => {
            props.change(
                'valor_baixado',
                numero(formulario.valor_original)
            );
            props.change('data_baixa', hoje());
        };

        return (
            <ContentCard>
                <Form event={props.handleSubmit}>
                    <ContentCardBody>
                        {origemAutomatica &&
                            <div className='alert alert-info'>
                                Este título foi gerado pela
                                {' '}{formulario.origem === 'COLETA'
                                    ? 'Coleta'
                                    : 'Aplicação'}.
                            </div>}

                        <Row>
                            <Field
                                name='data_emissao'
                                component={LabelAndInput}
                                type='date'
                                label='Data de emissão *'
                                cols='12 4 3 3'
                                readOnly={somenteLeitura}
                            />
                            <Field
                                name='data_vencimento'
                                component={LabelAndInput}
                                type='date'
                                label='Data de vencimento *'
                                cols='12 4 3 3'
                                readOnly={somenteLeitura}
                            />
                            <Field
                                name='id_plano_conta'
                                component={Select}
                                options={props.planosContas}
                                label='Plano de contas *'
                                cols='12 8 6 6'
                                readOnly={somenteLeitura}
                            />
                        </Row>

                        <Row>
                            {tipo === 'PAGAR'
                                ? <Field
                                    name='id_fornecedor'
                                    component={Select}
                                    options={props.fornecedores}
                                    label='Fornecedor *'
                                    cols='12 6 5 5'
                                    readOnly={somenteLeitura}
                                />
                                : <Field
                                    name='id_cliente'
                                    component={Select}
                                    options={props.clientes}
                                    label='Cliente *'
                                    cols='12 6 5 5'
                                    readOnly={somenteLeitura}
                                />}
                            <Field
                                name='descricao'
                                component={LabelAndInput}
                                label='Descrição *'
                                cols='12 6 7 7'
                                readOnly={somenteLeitura}
                            />
                        </Row>

                        <Row>
                            <Select
                                name='id_forma_pagamento'
                                options={props.formasPagamento}
                                label='Forma de pagamento *'
                                cols='12 6 4 4'
                                placeholder='Selecione'
                                readOnly={somenteLeitura}
                                value={formulario.id_forma_pagamento}
                                onChange={alterarFormaPagamento}
                            />
                            <Select
                                name='quantidade_parcelas'
                                options={PARCELAS}
                                label='Quantidade de vezes *'
                                cols='12 6 3 3'
                                placeholder='Selecione'
                                readOnly={
                                    somenteLeitura ||
                                    Boolean(formulario.id) ||
                                    !(formaPagamento || {})
                                        .permite_parcelamento
                                }
                                value={formulario.quantidade_parcelas}
                                onChange={valor =>
                                    props.change(
                                        'quantidade_parcelas',
                                        Number(valor)
                                    )}
                            />
                        </Row>

                        <Row>
                            <Field
                                name='valor_original'
                                component={LabelAndInputNumber}
                                label='Valor original *'
                                casas={2}
                                cols='12 4 3 3'
                                readOnly={somenteLeitura}
                            />
                            <Field
                                name='valor_baixado'
                                component={LabelAndInputNumber}
                                label={tipo === 'PAGAR'
                                    ? 'Valor pago'
                                    : 'Valor recebido'}
                                casas={2}
                                cols='12 4 3 3'
                                readOnly={somenteLeitura}
                            />
                            <Field
                                name='data_baixa'
                                component={LabelAndInput}
                                type='date'
                                label='Data da baixa'
                                cols='12 4 3 3'
                                readOnly={somenteLeitura || baixado <= 0}
                            />
                            {!props.cancelamento &&
                                <Grid cols='12 4 3 3'>
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                        style={{
                                            width: '100%',
                                            marginTop: 29
                                        }}
                                        onClick={marcarIntegral}
                                    >
                                        <i
                                            className='fas fa-check-circle'
                                            style={{ marginRight: 7 }}
                                        />
                                        {tipo === 'PAGAR'
                                            ? 'Marcar como pago'
                                            : 'Marcar como recebido'}
                                    </button>
                                </Grid>}
                        </Row>

                        <Row>
                            <Field
                                name='observacao'
                                component={LabelAndTextarea}
                                label='Observação'
                                rows={3}
                                cols='12 12 12 12'
                                readOnly={somenteLeitura}
                            />
                        </Row>
                    </ContentCardBody>

                    <ContentCardFooter>
                        <Row alignCenter>
                            <Grid cols='6 6 4 3'>
                                <Button
                                    text='Voltar'
                                    type='light'
                                    icon='fa fa-chevron-left'
                                    event={() => props.setModo(tipo, 'lista')}
                                />
                            </Grid>
                            <Grid cols='6 6 4 3'>
                                {props.cancelamento
                                    ? <Button
                                        text='Cancelar lançamento'
                                        submit
                                        type='danger'
                                        icon='fa fa-ban'
                                    />
                                    : <Button
                                        text='Salvar'
                                        submit
                                        type='success'
                                        icon='fa fa-check'
                                    />}
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                </Form>
            </ContentCard>
        );
    };

    FinanceiroForm = reduxForm({
        form: `financeiroForm${tipo}`,
        destroyOnUnmount: false
    })(FinanceiroForm);

    const chave = tipo === 'PAGAR' ? 'pagar' : 'receber';
    const mapStateToProps = state => {
        const opcoes = state.financeiro[chave].opcoes || {};

        return {
            formulario:
                getFormValues(`financeiroForm${tipo}`)(state) || {},
            planosContas: opcoes.planos_contas || [],
            clientes: opcoes.clientes || [],
            fornecedores: opcoes.fornecedores || [],
            formasPagamento: opcoes.formas_pagamento || []
        };
    };

    return connect(
        mapStateToProps,
        dispatch => bindActionCreators({ setModo }, dispatch)
    )(FinanceiroForm);
};

export default criarFormulario;
